import { Svg } from '../../utils/IconBase';
import { IconProps } from '../../utils/icon';

const IconEyeOffFill = ({ width, height, fill = 'currentColor', ...props }: IconProps) => {
  return (
    <Svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="m19.235 21.342-3.52-3.488a9.067 9.067 0 0 1-1.818.494A11.79 11.79 0 0 1 12 18.5c-2.105 0-4.033-.56-5.784-1.68a12.298 12.298 0 0 1-4.162-4.428 1.74 1.74 0 0 1-.178-1.35 1.7 1.7 0 0 1 .187-.434 27.04 27.04 0 0 1 1.272-1.924A8.44 8.44 0 0 1 4.9 7.039L2.642 4.765a.716.716 0 0 1-.212-.514.723.723 0 0 1 .228-.54.718.718 0 0 1 .527-.217c.206 0 .382.073.526.218l16.577 16.576c.139.139.212.31.22.515a.697.697 0 0 1-.22.54.718.718 0 0 1-.526.216.718.718 0 0 1-.527-.217ZM12 15.577c.222 0 .434-.013.636-.04.202-.026.399-.083.591-.172l-5.092-5.092c-.082.192-.138.39-.168.591-.03.202-.044.414-.044.636 0 1.135.396 2.098 1.187 2.89.792.791 1.755 1.187 2.89 1.187ZM12 4.5c2.111 0 4.048.563 5.81 1.688a12.184 12.184 0 0 1 4.17 4.454 1.677 1.677 0 0 1 .186 1.307 1.477 1.477 0 0 1-.17.409 12.9 12.9 0 0 1-1.019 1.634 11.54 11.54 0 0 1-1.26 1.444.927.927 0 0 1-.738.287 1.106 1.106 0 0 1-.739-.337L16.144 13.3a.756.756 0 0 1-.205-.36.869.869 0 0 1 .005-.425 3.568 3.568 0 0 0 .133-1.015c0-1.135-.396-2.098-1.188-2.89-.791-.791-1.754-1.187-2.889-1.187a3.434 3.434 0 0 0-.996.143.864.864 0 0 1-.442.015.758.758 0 0 1-.377-.206l-.931-.93c-.285-.285-.38-.617-.284-.995.096-.378.336-.62.72-.723a11.08 11.08 0 0 1 1.143-.171A12.13 12.13 0 0 1 12 4.5Zm1.937 5.112c.202.223.37.473.5.75.132.278.214.568.248.87.016.121-.029.205-.136.252-.107.046-.207.023-.301-.07l-2.146-2.137c-.094-.094-.114-.194-.063-.301a.267.267 0 0 1 .259-.16c.323.026.621.107.894.243.273.135.521.32.745.553Z"
        fill={fill}
      />
    </Svg>
  );
};

export default IconEyeOffFill;
